import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-pchatvideo',
  templateUrl: './pchatvideo.component.html',
  styleUrls: ['./pchatvideo.component.sass']
})
export class PchatvideoComponent implements OnInit {

  @Input('res') response: object;
  constructor() { }

  ngOnInit(): void {
  }

}
